<script lang="ts">
  interface Props {
    /** Side in pixels — the mark is square. */
    size?: number | undefined;
    /** What the mark means here. Omit where it is decorative and it is hidden from assistive tech. */
    label?: string | undefined;
  }

  const { size = 18, label }: Props = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 192 192"
  width={size}
  height={size}
  role={label === undefined ? undefined : 'img'}
  aria-label={label}
  aria-hidden={label === undefined ? 'true' : undefined}
>
  <rect width="192" height="192" rx="30" ry="30" fill="#288476" />
  <path
    fill="#ffffff"
    d="M122.7,71.5c-4-5.7-9.3-10.1-15.7-13.2c-6.5-3.1-14.1-4.6-23-4.6c-11.6,0-22,2.8-31.2,8.5
	C43.6,67.9,36.4,75.8,31.1,86c-5.3,10.1-7.9,21.6-7.9,34.3c0,12.7,2.6,24.1,7.8,34.1c1.9,3.7,4.1,7.2,6.6,10.3l12.7-12.7
	c0.2-0.2,0.4-0.2,0.6,0l3.2,3.2l13.8-13.8c-1-1.3-1.8-2.7-2.6-4.2c-2.6-5-3.9-10.8-3.9-17.3c0-6.4,1.3-12,3.9-17
	c2.6-4.9,6.3-8.9,11.1-11.8c4.8-2.9,10.3-4.4,16.5-4.4c6,0,11.4,1.4,16.2,4.3c4.8,2.9,8.5,6.8,11.2,11.8c2.7,5,4,10.7,4,17.1
	c0,6.7-1.3,12.5-4,17.5c-2.7,4.9-6.4,8.9-11.1,11.8c-4.7,2.9-10.1,4.4-16.3,4.4c-6.2,0-11.7-1.5-16.5-4.4c-0.6-0.4-1.2-0.8-1.8-1.2
	l-13.8,13.8l3.2,3.2c0.2,0.2,0.2,0.4,0,0.6l-12.1,12.1c0.2,0.1,0.3,0.2,0.5,0.3c9,5.7,19.2,8.5,30.4,8.5c6.9,0,12.9-0.9,18-2.6
	c5.1-1.8,9.5-4.1,13.1-7.2c3.6-3,6.4-6.3,8.9-9.8v16.6h37.7V7.6h-37.7V71.5z"
  />
</svg>

<style>
  svg {
    display: block;
  }
</style>
